import { Service } from '@angular/core';
import { BaseMessageService } from '@services/messages';

@Service({ autoProvided: false })
export class MbmModalMessageService extends BaseMessageService {}
